




















































































import { Component, Vue, Prop } from "vue-property-decorator";
import ChipsContainer from "@/components/Communities/ChipsContainer.vue";
import ModalEdit from "@/components/ModalEdit.vue";

@Component({
    components: {
        ChipsContainer,
        ModalEdit
    }
})
export default class Leaders extends Vue {
    public showEditDialog: boolean = false;
    public titleModalEdit: string = "Add leaders";
    public users: any = [];
    public showSpinner: boolean = false;
    public input: string = "";

    @Prop() value: any;

    get leaderSearch(){
        return this.$communityApi.getUsers(this.input) || [];
    }

    public removeLeader(uid) {
        const index = this.value.findIndex(v => v.uid === uid);
        if (index !== -1) {
            this.value.splice(index, 1);
        }
    }
    // public async leaderSearch(input) {
    //     if (input && input !== "") {
    //         this.showSpinner = true;
    //         this.users = await this.$communityApi.getUsers(input);
    //         this.users.length || (this.users = [{ name: "No results" }]);
    //         this.showSpinner = false;
    //     } else {
    //         this.users = [];
    //     }
    // }
    public addLeader(user) {
        this.value.push(user);
        this.users = [];
        this.input = "";
    }
    public checkDisabledUser(item) {
        let check = false;
        if (item.name === "No results") {
            return true;
        }
        this.value.forEach(el => {
            if (el.mail === item.mail) {
                check = true;
                return;
            }
        });
        return check;
    }
    public emptyOnHide() {
        this.users = [];
        this.input = "";
    }
}
